// extracted by mini-css-extract-plugin
export default {"modify_order_header":"pz","center":"qz","empty":"rz","pending":"sz","referralTitle":"tz","wrapper":"uz","title":"vz","tabs":"wz","tab":"xz","active":"yz","btn":"zz","rewards_table":"Az"};
    if(module.hot) {
      // 1737143655279
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  